import type { Deliverable } from '../../types/managerReviewV2';

/**
 * Deliverables carry a stable id: AI callbacks still in flight after a card is removed must find
 * their own deliverable (or nothing), never the one that moved into its position.
 */
export const newDeliverableId = (): string =>
  typeof crypto !== 'undefined' && 'randomUUID' in crypto ? crypto.randomUUID() : `d-${Date.now()}-${Math.random().toString(36).slice(2)}`;

export const newDeliverable = (): Deliverable => ({
  id: newDeliverableId(), title: '', rating: null, competencies: [], wellDone: '', improvement: '',
});

/** Drafts saved before ids existed get one on restore. */
export const withIds = (list: Deliverable[]): Deliverable[] => list.map(d => (d.id ? d : { ...d, id: newDeliverableId() }));
